import type { Html, Root } from "mdast";
import { visit } from "unist-util-visit";

import {
  parseReferenceAttributes,
  REFERENCE_ATTRS_PATTERN,
  REFERENCE_TAG,
} from "src/base-components/Chat/PromptBox/mentionContent";

export const REFERENCE_ELEMENT_TAG = "tktl-reference";

const REFERENCE_HTML_RE = new RegExp(
  `^\\s*<${REFERENCE_TAG}(${REFERENCE_ATTRS_PATTERN})\\s*/>\\s*$`,
);

/**
 * Rewrites `<reference .../>` html nodes to a custom node with
 * `hName`/`hProperties` so a `tktl-reference` element is emitted.
 * Non-matching html nodes are left untouched (fail open).
 */
export const remarkReference = () => {
  return (tree: Root) => {
    visit(tree, "html", (node: Html) => {
      const match = node.value.match(REFERENCE_HTML_RE);
      if (!match) return;
      const rawAttrs = match[1] ?? "";
      const attrs = parseReferenceAttributes(rawAttrs);
      if (!attrs.id || !attrs.label) return;
      Object.assign(node, {
        type: "tktlReference",
        data: {
          hName: REFERENCE_ELEMENT_TAG,
          hProperties: { "data-reference": rawAttrs },
        },
      });
    });
  };
};
